import React from 'react';
import './CategoryFilter.css';

const categories = [
  { id: 'all', label: 'All', icon: null },
  { id: 'vectors', label: 'Vectors', icon: '⚙' },
  { id: 'photos', label: 'Photos', icon: '📷' },
  { id: 'psds', label: 'PSDs', icon: '📄' },
  { id: 'icons', label: 'Icons', icon: '⭐' },
  { id: 'templates', label: 'Templates', icon: '📋' }
];

function CategoryFilter({ selectedCategory, onCategoryChange }) {
  return (
    <div className="category-filter">
      <h2 className="category-title">Browse by Category</h2>
      <div className="category-buttons">
        {categories.map(category => (
          <button
            key={category.id}
            className={`category-button ${selectedCategory === category.id ? 'active' : ''}`}
            onClick={() => onCategoryChange(category.id)}
          >
            {category.icon && <span className="category-icon">{category.icon}</span>}
            <span>{category.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default CategoryFilter;
